import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    boxContainer: {
        marginTop: "32px",
        width: "100%",
    }
}));
